// Product types ตาม API schema

/** เพศของไก่ */
export enum ChickenGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

/** รายการ media ของสินค้า (รูปภาพและวิดีโอ) */
export interface MediaItem {
  name: string
  size: number
  type: 'image' | 'video'
  url: string
  sequence?: number
}

/** ข้อมูลสินค้า */
export interface Product {
  /** รหัสของสินค้า */
  id: string

  /** รหัสของร้านค้าที่สร้างสินค้า */
  createdByShopId: string

  /** ชื่อร้านค้าที่สร้างสินค้า */
  createdByShopName: string

  /** ชื่อสินค้า */
  name: string

  /** รายละเอียดสินค้า */
  description: string

  /** ราคาสินค้า */
  price: number

  /** ส่วนลดของสินค้า (เป็นจำนวนเงิน) */
  discount?: number

  /** รหัสหมวดหมู่ของสินค้า */
  categoryId: string

  /** รายการ media ของสินค้า (รูปภาพและวิดีโอ) */
  mediaUrls: MediaItem[]

  /** จำนวนสินค้าคงเหลือ */
  stock: number

  /** สถานะการใช้งานของสินค้า
   * true - สินค้ายังขายอยู่
   * false - สินค้าถูกระงับการขาย */
  isActive: boolean

  /** วันที่สร้างสินค้า */
  createdAt: Date

  /** วันที่อัพเดทสินค้าล่าสุด */
  updatedAt: Date

  // ข้อมูลไก่
  /** รหัสไก่ */
  chickenCode?: string

  /** วันเกิดไก่ */
  chickenBirthdate?: Date

  /** เพศไก่ */
  chickenGender?: ChickenGender

  /** ไก่ชนหรือไม่ */
  isChickenFighting?: boolean
}

/** Pagination response type */
export interface ProductsPaginationResponse<T> {
  items: T[]
  total: number
}

/** Product filter types */
export interface ProductFilters {
  page: number
  limit: number
  search: string
  status: ProductStatus
  orderBy: string
  productCategoryId?: string
  shopId?: string
}

/** Product status enum สำหรับ filter tabs */
export enum ProductStatus {
  ALL = 'All',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DRAFT = 'DRAFT',
}

/** Table column type */
export interface ProductTableColumn {
  id: string
  label: string
  sortable?: boolean
}

/** Product form data type */
export interface ProductFormData {
  name: string
  description: string
  price: number
  discount?: number
  categoryId: string
  mediaUrls: MediaItem[]
  stock: number
  isActive: boolean
  // Chicken fields (optional for form)
  chickenCode?: string
  chickenBirthdate?: Date
  chickenGender?: ChickenGender
  isChickenFighting?: boolean
}
